// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "version": "3056ef0f7f51eae070074a1a0cb87b98d22f3423"
};
/* tslint:enable */
